var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavorisSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9585 1.23033C19.5972 0.478462 18.8337 0 17.9951 0C17.1566 0 16.3998 0.478462 16.0317 1.23033L11.6481 10.2733L1.8582 11.7223C1.0401 11.8454 0.358356 12.4195 0.10611 13.2056C-0.146136 13.9916 0.0583876 14.8597 0.644688 15.4407L7.74847 22.4877L6.07138 32.4466C5.93503 33.2668 6.2759 34.1007 6.95083 34.586C7.62576 35.0713 8.51885 35.1328 9.25513 34.7432L18.0019 30.0611L26.7487 34.7432C27.485 35.1328 28.3781 35.0781 29.053 34.586C29.7279 34.0938 30.0688 33.2668 29.9325 32.4466L28.2486 22.4877L35.3523 15.4407C35.9386 14.8597 36.15 13.9916 35.8909 13.2056C35.6319 12.4195 34.9569 11.8454 34.1388 11.7223L24.3422 10.2733L19.9585 1.23033Z",
    fill: "#FFD43B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavorisSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FavorisSelected.c886e9b62352a2e22c7b201891404a2c.svg";